module.exports = __webpack_public_path__ + "img/koi_nmg_xxlogo.e568eb38.png";